import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0040',
    ecrans: ['00-2'],
    params: ['id']
});
